var __assign = Object.assign;
export function isEmptyElement(c) {
  return !(c.tag || c.text && c.text.trim() !== "");
}
export function filterEmpty(children = []) {
  return children.filter((c) => !isEmptyElement(c));
}
export function getPropsData(ele) {
  let componentOptions = ele.componentOptions;
  if (ele.$vnode) {
    componentOptions = ele.$vnode.componentOptions;
  }
  return componentOptions ? componentOptions.propsData || {} : {};
}
;
export function getValueByProp(ele, prop) {
  return getPropsData(ele)[prop];
}
;
export function getComponentFromProp(instance, prop, options = instance, execute = true) {
  if (instance.$createElement) {
    const h = instance.$createElement;
    const temp = instance[prop];
    if (temp !== void 0) {
      return typeof temp === "function" && execute ? temp(h, options) : temp;
    }
    return instance.$slots[prop] || instance.$scopedSlots[prop] && execute && instance.$scopedSlots[prop](options) || instance.$scopedSlots[prop] || void 0;
  } else {
    const h = instance.context.$createElement;
    const temp = getPropsData(instance)[prop];
    if (temp !== void 0) {
      return typeof temp === "function" && execute ? temp(h, options) : temp;
    }
    const slotsProp = [];
    const componentOptions = instance.componentOptions || {};
    (componentOptions.children || []).forEach((child) => {
      if (child.data && child.data.slot === prop) {
        if (child.tag === "template") {
          slotsProp.push(child.children);
        } else {
          slotsProp.push(child);
        }
      }
    });
    return slotsProp.length ? slotsProp : void 0;
  }
}
;
function getType(fn) {
  const match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : "";
}
function filterProps(props, propsData = {}) {
  const res = {};
  Object.keys(props).forEach((k) => {
    if (k in propsData || props[k] !== void 0) {
      res[k] = props[k];
    }
  });
  return res;
}
;
export function hasProp(vm, key) {
  if (!vm.$options.propsData)
    return false;
  return key in vm.$options.propsData && vm.$options.propsData[key] !== void 0;
}
export function getOptionProps(instance) {
  if (instance.componentOptions) {
    const componentOptions = instance.componentOptions;
    const {propsData = {}, Ctor = {}} = componentOptions;
    const props = (Ctor.options || {}).props || {};
    const res = {};
    for (const [k, v] of Object.entries(props)) {
      const def = v.default;
      if (def !== void 0) {
        res[k] = typeof def === "function" && getType(v.type) !== "Function" ? def.call(instance) : def;
      }
    }
    return __assign(__assign({}, res), propsData);
  }
  const {$options = {}, $props = {}} = instance;
  return filterProps($props, $options.propsData);
}
;
export function getVnodeName(instance) {
  return instance.componentOptions.Ctor.options.name;
}
